module.exports = __webpack_public_path__ + "img/portfolio-grid-layout-light.20ed7a06.png";